// extracted by mini-css-extract-plugin
export var header = "Header-module--header--Kmy2n";
export var titleNavWrapper = "Header-module--titleNavWrapper--3Qgdz";
export var nameContainer = "Header-module--nameContainer--1Tcxn";
export var siteTitle = "Header-module--siteTitle--bNbbd";
export var desktopNav = "Header-module--desktopNav--2h5pm";
export var mainNav = "Header-module--mainNav--1GhXY";